import React from 'react';
import OBNDBNBizBrandMappingListComponent from './obn-dbn-biz-brand-mapping/containers/brand-mappings';
import OBNDBNBizBasicInfoComponent from './obn-dbn-biz-basic-info.component';
import OBNDBNBizKeyInfoComponent from './obn-dbn-biz-key.component';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';

export const OBNDBNBizComponent = ({openNetworkRegistries,bizNetTypes,
  dbnpregistries, oBNDBNBizsList, deliveryPreference, accountType, deleteKeys, onFormItemChange, keys,
  onFormChange, obnDBNBiz, fetchAcount, accounts, shippingProviders, id, selectedOBNDBNBiz, shippingTypes, back,
  handleFormSubmit, shippingOptionList
}: any) => {

  const tabItems = [
    {
      id: 0,
      title: `OBN Biz - Basic Details`,
      component: <OBNDBNBizBasicInfoComponent
      obnDBNBiz={obnDBNBiz}
        id={id}
        selectedOBNDBNBiz={selectedOBNDBNBiz}
        shippingTypes={shippingTypes}
        shippingProviders={shippingProviders}
        deliveryPreference={deliveryPreference}
        onFormChange={onFormChange}
        shippingOptionList={shippingOptionList}
        oBNDBNBizsList={oBNDBNBizsList}
        openNetworkRegistries={openNetworkRegistries}
        bizNetTypes={bizNetTypes}
      />,
      isVisible: true,
    },
    {
      id: 1,
      title: 'Key Details',
      component: <OBNDBNBizKeyInfoComponent
        keys={keys}
        onFormItemChange={onFormItemChange}
        deleteKeys={deleteKeys}
      />,
      isVisible: true,
    },
    // {
    //   id: 2,
    //   title: 'Brand Mapping',
    //   component: <OBNDBNBizBrandMappingListComponent
    //     obnDBNBiz={obnDBNBiz}
    //   />,
    //   isVisible: id > 0 ? true : false,
    // },
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">

      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
      
          <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
            onClick={handleFormSubmit}
            type="submit"
          >
            Save
          </button>
        
      </div>
    </div>
  )
}
export default OBNDBNBizComponent;
